"use client";

import { useSyncExternalStore } from "react";
import type { CodeLang } from "@/lib/code-lang";
import type { TimeToReadByLang } from "@/lib/reading-time.mjs";

interface ReadingTimeProps {
  /** 기본값(분). 언어별 값이 있으면 기본 언어 값 */
  minutes: string | number;
  byLang?: TimeToReadByLang;
}

// LanguageToggle 이 선택 언어를 <html data-code-lang> 에 기록한다. 이 줄은 본문 밖이라
// CodeLangProvider(MDXContentWrapper) 바깥에 있으므로 context 대신 속성 변화를 구독한다.
function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-code-lang"],
  });
  return () => observer.disconnect();
}

function getCodeLang(): CodeLang | null {
  return document.documentElement.getAttribute("data-code-lang") as CodeLang | null;
}

/** "읽는데 N분 소요". 공통 코딩 페이지는 LanguageToggle 에서 고른 언어의 값을 보여준다. (JCG-4099) */
export default function ReadingTime({ minutes, byLang }: ReadingTimeProps) {
  const lang = useSyncExternalStore(subscribe, getCodeLang, () => null);
  const langMinutes = lang ? byLang?.[lang] : undefined;

  return <div>읽는데 {langMinutes ?? minutes}분 소요</div>;
}
